<template>
  <PageLayout>
    <div class="text-right pb-14">
      <span class="navy--text">Máte potíže?</span>
      <router-link to="/" class="link link-underline navy--text ml-2"
        >Pomoc</router-link
      >
    </div>

    <h2 class="text-h3 navy--text text--darken-1 font-weight-bold pb-2">
      Vyberte reklamní účet, se kterým chcete začít
    </h2>
    <p class="body-2 navy--text text--darken-1 pb-10">
      V současné době lze do Adveroo přidat pouze jeden reklamní účet
    </p>

    <v-row justify="center">
      <v-col :lg="6">
        <div class="mb-4 d-flex justify-end">
          <v-btn
            text
            small
            class="navy--text text--darken-1"
            :disabled="busy"
            @click="loadAdAccounts()"
          >
            <img
              class="mr-2"
              :src="require('@/assets/ico-refresh.svg')"
              alt=""
            />
            Aktualizovat
          </v-btn>
        </div>

        <v-select
          :loading="busy"
          label="Reklamní účet"
          outlined
          :items="adAccounts"
          item-text="name"
          item-value="id"
          v-model="adAccountId"
        />

        <!--        <v-alert v-if="adAccounts.error" type="error" outlined text>-->
        <!--          Něco se pokazilo-->
        <!--        </v-alert>-->

        <div class="d-flex justify-center mt-12">
          <v-btn
            color="facebook"
            dark
            :href="facebookLink"
            target="_blank"
            rel="noreferrer noopener"
          >
            <v-icon left>mdi-facebook</v-icon> Vytvořit Reklamní účet
          </v-btn>
        </div>
      </v-col>
    </v-row>

    <template #footer>
      <v-row>
        <v-col>
          <v-btn color="white" class="c-btn" @click="goBack" min-width="186">
            Zpět
          </v-btn>
        </v-col>

        <v-col class="text-right">
          <v-btn
            color="primary"
            class="c-btn"
            min-width="186"
            :disabled="!isValid()"
            @click="goNext"
          >
            Pokračovat
            <v-icon right>mdi-arrow-right</v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </template>
  </PageLayout>
</template>

<script>
import { call, get, sync } from "vuex-pathify"

import PageLayout from "@/components/page/onboard/PageLayout.vue"
import store from "@/store"

const PREV_ROUTE = "/onboard/connect/business-manager"
const NEXT_ROUTE = "/onboard/subscription"

export default {
  name: "AdAccount",
  components: {
    PageLayout,
  },
  beforeRouteEnter(to, from, next) {
    if (!store.state.accounts.businessId) {
      next(PREV_ROUTE)
    } else {
      next()
    }
  },
  computed: {
    ...get("accounts", ["adAccounts", "businessId", "busy"]),
    ...sync("accounts", ["adAccountId"]),
    facebookLink() {
      return `https://business.facebook.com/settings/ad-accounts?business_id=${store.state.accounts.selectedBusinessId}`
    },
  },
  methods: {
    ...call("accounts", ["loadAdAccounts"]),
    isValid() {
      return !!this.adAccountId
    },
    goBack() {
      this.$router.push(PREV_ROUTE)
    },
    goNext() {
      this.$router.push(NEXT_ROUTE)
    },
  },
  mounted() {
    this.loadAdAccounts(this.businessId)
  },
  // setup() {
  //   onMounted(() => {
  //     store.dispatch("accounts/fetchAdAccounts")
  //   })
  //
  //   const facebookLink = `https://business.facebook.com/settings/ad-accounts?business_id=${store.state.accounts.selectedBusinessId}`
  //
  //   return {
  //     // Ad accounts
  //     adAccounts: computed(() => store.state.accounts.adAccounts),
  //     selectedAdAccountId: computed({
  //       get: () => store.state.accounts.selectedAdAccountId,
  //       set: value => store.dispatch("accounts/selectAdAccount", value),
  //     }),
  //     reloadAdAccounts: () => store.dispatch("accounts/fetchAdAccounts"),
  //     // Navigation
  //     goNextEnabled: computed(
  //       () => store.state.accounts.selectedAdAccountId !== null
  //     ),
  //     goBack() {
  //       router.push(PREV_ROUTE)
  //     },
  //     goNext() {
  //       router.push(NEXT_ROUTE)
  //     },
  //     // Other
  //     facebookLink,
  //   }
  // },
}
</script>
